export default __webpack_public_path__ + "static/rtl-02b505a5ddf06c2c8ec76ef8aee7ea38.gif";